var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6438 7.56568C20.4814 7.09438 20.0511 6.75432 19.5322 6.68273L14.2822 5.96285L11.9346 1.4805C11.4706 0.593576 9.93288 0.593576 9.46884 1.4805L7.1212 5.96285L1.88384 6.68273C1.36496 6.75432 0.934662 7.09637 0.774357 7.56568C0.611942 8.03698 0.749045 8.55005 1.1245 8.89408L4.92122 12.3742L4.02688 17.3C3.93829 17.7852 4.15133 18.2784 4.57318 18.5687C4.99715 18.8571 5.55822 18.8949 6.02226 18.6662L10.7028 16.3395L15.3959 18.6662C15.5963 18.7656 15.8178 18.8153 16.0351 18.8153C16.3198 18.8153 16.6046 18.7318 16.8471 18.5687C17.2711 18.2764 17.482 17.7852 17.3934 17.3L16.4991 12.3742L20.2958 8.89408C20.6713 8.55204 20.8063 8.035 20.6438 7.56568Z",
    fill: "#4E5574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarGray);
export default __webpack_public_path__ + "static/media/icon-star-gray.413adcc78bdcb64894116dc9a932efb8.svg";
export { ForwardRef as ReactComponent };